import * as z from 'zod';

export const pageNumberSchema = z.int().min(1).prefault(1);
export const pageSizeSchema = z.int().min(10).max(100).prefault(20);

export const paginationRequestSchema = z.object({
  /**
   * Current page number
   */
  pageNumber: pageNumberSchema,

  /**
   * Number of items per page
   */
  pageSize: pageSizeSchema,
});

export const paginationResponseSchema = z.object({
  /**
   * Total number of items
   */
  totalItems: z.int().min(0),

  /**
   * Total number of pages
   */
  totalPages: z.int().min(0),
});

export type PaginationRequest = z.infer<typeof paginationRequestSchema>;
export type PaginationResponse = z.infer<typeof paginationResponseSchema>;

export const getSkipTakeFromPagination = (
  pagination: PaginationRequest,
): { skip: number; take: number } => {
  const { pageNumber, pageSize } = pagination;
  const skip = (pageNumber - 1) * pageSize;
  const take = pageSize;

  return { skip, take };
};

export const getPaginationResponse = ({
  totalItems,
  pageSize,
}: {
  totalItems: number;
  pageSize: number;
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  return paginationResponseSchema.parse({
    totalItems,
    totalPages,
  });
};
